export default {
	errorTitle: 'An Error Occurred',
	errorText:
		'The link for confirming your account is incorrect or no longer valid. Please contact support.',
	validatedTitle: 'Confirmation',
	validatedText:
		'Please provide a password in order to log in to the HubeeConnect platform.',
	acceptCGU: 'I have read and accept the Terms and Conditions',
}
